import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from 'src/app/state';

@Injectable({
  providedIn: 'root',
})
export class RoleEnabledGuard {
  public constructor(
    private readonly sessionService: SessionService,
    private readonly router: Router
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<UrlTree | boolean> | Promise<UrlTree | boolean> | UrlTree | boolean {
    switch (route.url[0].path) {
      case 'select-role':
        if (this.sessionService.hasRole()) {
          return this.router.parseUrl('/data/design');
        }

        return true;
      default:
        if (this.sessionService.hasRole()) {
          return true;
        }

        return this.router.parseUrl('/select-role');
    }
  }
}
